import React, { useCallback } from 'react';
import { Alert, Box, Chip, Typography } from '@mui/material';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { superAdminAPI } from '../../services/api';
import { SuperAdminTogglePage } from './SuperAdminTogglePage';
import {
  ASSIGNABLE_CORE_MODULE_ITEMS,
  SYSTEM_ALWAYS_ON_MODULES,
} from '../../config/assignableCoreModules';
import { getPageSubtitle } from '../../constants/pageSubtitles';
import { brandCss } from '../../theme/appTheme';

export const CoreModulesPage: React.FC = () => {
  const load = useCallback(async () => {
    const data = (await superAdminAPI.getCoreModules()).data as Record<string, boolean>;
    const allowed = new Set<string>(ASSIGNABLE_CORE_MODULE_ITEMS.map((m) => m.key));
    return Object.fromEntries(Object.entries(data || {}).filter(([key]) => allowed.has(key)));
  }, []);

  const save = useCallback(async (data: Record<string, boolean>) => {
    const allowed = new Set<string>(ASSIGNABLE_CORE_MODULE_ITEMS.map((m) => m.key));
    const payload = Object.fromEntries(Object.entries(data).filter(([key]) => allowed.has(key)));
    await superAdminAPI.updateCoreModules(payload);
  }, []);

  const systemNote = (
    <Alert severity="info" sx={{ mb: 2 }} icon={false}>
      <Typography fontSize={12} fontWeight={600} sx={{ mb: 0.75 }}>
        System modules (always on)
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {SYSTEM_ALWAYS_ON_MODULES.map((m) => (
          <Chip key={m.key} label={m.label} size="small" sx={{ bgcolor: brandCss.green100, color: brandCss.primaryDark, fontWeight: 600, fontSize: 11 }} />
        ))}
      </Box>
    </Alert>
  );

  return (
    <Box>
      <SuperAdminTogglePage
        title="Core Modules"
        icon={<ViewModuleIcon />}
        subtitle={getPageSubtitle('core_modules')}
        breadcrumb="Core Modules"
        items={[...ASSIGNABLE_CORE_MODULE_ITEMS]}
        load={load}
        save={save}
        infoBelow={systemNote}
      />
    </Box>
  );
};
